const TABLE_DIALOG_ID = 'table-expand';
export const dialogIdSelector = `#${TABLE_DIALOG_ID}-dialog`;

// As of writing, this is also the default width that exportData is provided by "react-table-plugins"
export const DEFAULT_COL_WIDTH = 150;
export const MIN_COLUMN_WIDTH = 40;
